export default "__VITE_ASSET__CGgtpq8i__"